<template>
  <div class="main" style="min-height: 768px;">
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">{{ form.id ? '編輯宿舍巡查' : '新增宿舍巡查' }}</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">系統填寫日期：</label>
            <div class="col-xs-8 col-md-7">{{ systemDateText }}</div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>巡查日期：</label>
            <div class="col-xs-8 col-md-7">
              <datepicker
                :format="customFormatter"
                :language="zh"
                v-model="form.patrolDate"
                input-class="form-control topIndex"
                :style="{ width: 'auto', display: 'inline-block' }"
              />
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>巡查時間：</label>
            <div class="col-xs-8 col-md-7 patrol-time-select-group">
              <select class="form-control patrol-time-select" v-model="form.patrolHour">
                <option value="">時</option>
                <option v-for="hour in patrolHourOptions" :key="'hour-' + hour" :value="hour">{{ hour }}</option>
              </select>
              <span class="patrol-time-separator">:</span>
              <select class="form-control patrol-time-select" v-model="form.patrolMinute">
                <option value="">分</option>
                <option v-for="minute in patrolMinuteOptions" :key="'minute-' + minute" :value="minute">{{ minute }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5"><span class="text-danger">*</span>學期：</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.smtr">
                <option value="">--請選擇--</option>
                <option v-for="(item, index) in selectYear()" :key="index" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label><span class="text-danger">*</span>定期巡查狀況：</label>
            <textarea class="form-control" rows="5" v-model="form.regularPatrolStatus"></textarea>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>
              <span class="text-danger">*</span>設施異常狀況：
            </label>
            <label style="margin-left: 15px; margin-right: 15px;">
              <input type="radio" value="Y" v-model="form.hasFacilityIssue" @change="onFacilityIssueChange" /> 有
            </label>
            <label>
              <input type="radio" value="N" v-model="form.hasFacilityIssue" @change="onFacilityIssueChange" /> 無
            </label>
            <button v-if="form.hasFacilityIssue === 'Y'" type="button" class="btn btn-default btn-sm" style="margin-left: 15px;" @click="addFacility">新增</button>
          </div>
        </div>

        <div v-if="form.hasFacilityIssue === 'Y'" class="row form-group">
          <div class="col-md-12">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="20%">宿舍名稱</th>
                  <th class="text-center" width="20%">樓層</th>
                  <th class="text-center">異常說明</th>
                  <th class="text-center" width="10%">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in form.facilities" :key="'facility-' + index">
                  <td>
                    <select class="form-control" v-model="item.dormitoryName" @change="onFacilityDormitoryChange(item)">
                      <option value="">--請選擇--</option>
                      <option v-for="(dormitory, dormitoryIndex) in dormitoryList" :key="dormitoryIndex" :value="dormitory">{{ dormitory }}</option>
                    </select>
                  </td>
                  <td>
                    <select class="form-control" v-model="item.floorName">
                      <option value="">--請選擇--</option>
                      <option v-for="(floor, floorIndex) in floorOptions(item.dormitoryName)" :key="floorIndex" :value="floor">{{ floor }}</option>
                    </select>
                  </td>
                  <td>
                    <textarea class="form-control" rows="3" v-model="item.issueRemark" maxlength="1000"></textarea>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger btn-sm" @click="removeFacility(index)">刪除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>
              <span class="text-danger">*</span>偶(突)發事件處理：
            </label>
            <label style="margin-left: 15px; margin-right: 15px;">
              <input type="radio" value="Y" v-model="form.hasIncident" @change="onIncidentChange" /> 有
            </label>
            <label>
              <input type="radio" value="N" v-model="form.hasIncident" @change="onIncidentChange" /> 無
            </label>
            <button v-if="form.hasIncident === 'Y'" type="button" class="btn btn-default btn-sm" style="margin-left: 15px;" @click="addIncidentStudent">新增學生</button>
          </div>
        </div>

        <div v-if="form.hasIncident === 'Y'" class="row form-group">
          <div class="col-md-12">
            <label>偶(突)發事件處理說明：</label>
            <textarea class="form-control" rows="4" v-model="form.incidentHandleRemark"></textarea>
          </div>
        </div>

        <div v-if="form.hasIncident === 'Y'" class="row form-group">
          <div class="col-md-12">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="18%">學號</th>
                  <th class="text-center" width="12%">姓名</th>
                  <th class="text-center" width="10%">性別</th>
                  <th class="text-center" width="20%">宿舍</th>
                  <th class="text-center" width="15%">寢室</th>
                  <th class="text-center" width="10%">床位</th>
                  <th class="text-center" width="15%">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in form.incidentStudents" :key="'incident-' + index">
                  <td>
                    <div class="patrol-student-lookup">
                      <input type="text" class="form-control" v-model="item.account" />
                      <button type="button" class="btn btn-default patrol-student-lookup-btn" @click="lookupStudent(item)">查詢</button>
                    </div>
                  </td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ item.sex }}</td>
                  <td class="text-center">{{ item.dormitoryName }}</td>
                  <td class="text-center">{{ item.bedRoom }}</td>
                  <td class="text-center">{{ item.bed }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger btn-sm" @click="removeIncidentStudent(index)">刪除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>學生反映事項：</label>
            <textarea class="form-control" rows="4" v-model="form.studentFeedback"></textarea>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label><span class="text-danger">*</span>學生違規事項：</label>
            <select class="form-control" v-model="form.violationItem" @change="onViolationChange">
              <option value="">--請選擇--</option>
              <option v-for="(item, index) in violationList" :key="index" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>

        <div v-if="form.violationItem !== noViolationItem" class="row form-group">
          <div class="col-md-12 text-right" style="margin-bottom: 8px;">
            <button type="button" class="btn btn-default btn-sm" @click="addViolationStudent">新增學生</button>
          </div>
          <div class="col-md-12">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="18%">學號</th>
                  <th class="text-center" width="12%">姓名</th>
                  <th class="text-center" width="10%">性別</th>
                  <th class="text-center" width="20%">宿舍</th>
                  <th class="text-center" width="15%">寢室</th>
                  <th class="text-center" width="10%">床位</th>
                  <th class="text-center" width="15%">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in form.violationStudents" :key="'violation-' + index">
                  <td>
                    <div class="patrol-student-lookup">
                      <input type="text" class="form-control" v-model="item.account" />
                      <button type="button" class="btn btn-default patrol-student-lookup-btn" @click="lookupStudent(item)">查詢</button>
                    </div>
                  </td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ item.sex }}</td>
                  <td class="text-center">{{ item.dormitoryName }}</td>
                  <td class="text-center">{{ item.bedRoom }}</td>
                  <td class="text-center">{{ item.bed }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger btn-sm" @click="removeViolationStudent(index)">刪除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-offset-4 col-md-2">
            <a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious">返回</a>
          </div>
          <div class="col-md-2">
            <a href="javascript:;" class="btn btn-primary btn-block" @click="savePatrol">儲存</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

const NO_VIOLATION_ITEM = "無";
const DORMITORY_FLOOR_MAP = {
  高爾夫宿舍: ["19樓", "20樓"],
  香檳宿舍: ["9樓", "10樓"],
  誠堡宿舍: ["2樓", "10樓", "11樓", "12樓"],
  元居宿舍: ["3樓", "4樓", "5樓", "6樓", "7樓", "8樓", "9樓", "10樓"],
};

function createFacility() {
  return {
    dormitoryName: "",
    floorName: "",
    issueRemark: "",
  };
}

function createStudent() {
  return {
    applyId: null,
    account: "",
    name: "",
    sex: "",
    dormitoryName: "",
    bedRoom: "",
    bed: "",
  };
}

function createDefaultForm() {
  const patrolTime = createCurrentPatrolTime();
  return {
    id: null,
    smtr: "",
    patrolDate: new Date(),
    patrolHour: patrolTime.hour,
    patrolMinute: patrolTime.minute,
    regularPatrolStatus: "",
    hasFacilityIssue: "N",
    hasIncident: "",
    incidentHandleRemark: "",
    studentFeedback: "",
    violationItem: "",
    crDate: null,
    facilities: [],
    incidentStudents: [],
    violationStudents: [],
  };
}

function padTwoDigits(value) {
  return String(value).padStart(2, "0");
}

function createCurrentPatrolTime() {
  const now = new Date();
  return {
    hour: padTwoDigits(now.getHours()),
    minute: padTwoDigits(now.getMinutes()),
  };
}

function parsePatrolTime(value) {
  const normalized = (value || "").trim();
  if (!normalized) {
    return createCurrentPatrolTime();
  }

  const match = normalized.match(/(\d{1,2}):(\d{1,2})/);
  if (!match) {
    return createCurrentPatrolTime();
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (Number.isNaN(hour) || Number.isNaN(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
    return createCurrentPatrolTime();
  }

  return {
    hour: padTwoDigits(hour),
    minute: padTwoDigits(minute),
  };
}

function toPatrolTimeText(hour, minute) {
  if (hour === "" || minute === "") {
    return "";
  }
  return `${hour}:${minute}`;
}

function normalizeAccount(account) {
  return (account || "").trim().toUpperCase();
}

export default {
  data() {
    return {
      form: createDefaultForm(),
      dormitoryList: [],
      patrolHourOptions: Array.from({ length: 24 }, (_, index) => padTwoDigits(index)),
      patrolMinuteOptions: Array.from({ length: 60 }, (_, index) => padTwoDigits(index)),
      violationList: [NO_VIOLATION_ITEM],
      noViolationItem: NO_VIOLATION_ITEM,
    };
  },
  computed: {
    systemDateText() {
      const targetDate = this.form.crDate ? new Date(this.form.crDate) : new Date();
      return this.customFormatter(targetDate);
    },
  },
  methods: {
    guardAccess() {
      if (this.isAdmin("stay")) {
        return true;
      }
      bootbox.alert("無宿舍巡查權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },
    selectYear() {
      let smtrArray = [];
      let nowYear = new Date().getFullYear() - 1911;
      let nowMonth = new Date().getMonth() + 1;
      if (nowMonth < 8) {
        nowYear = nowYear - 1;
      }
      for (let y = nowYear; y > 100; y--) {
        if ((y === nowYear && nowMonth < 8) || y < nowYear) {
          smtrArray.push({ text: y + "年第二學期", value: y + "2" });
        }
        smtrArray.push({ text: y + "年第一學期", value: y + "1" });
      }
      return smtrArray;
    },
    init() {
      const api = "/api/DormitoryPatrol/init";
      this.$axios.get(api).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "載入宿舍巡查初始化資料失敗");
          return;
        }

        this.dormitoryList = resp.data.data.dormitoryList || [];
        this.violationList = (resp.data.data.violationList || []).map((item) => {
          if (typeof item === "string") {
            return item;
          }
          return item.value;
        }).filter((item, index, array) => array.indexOf(item) === index);
        if (this.violationList.indexOf(NO_VIOLATION_ITEM) === -1) {
          this.violationList.unshift(NO_VIOLATION_ITEM);
        }

        if (!this.form.smtr) {
          const years = this.selectYear();
          if (years.length > 0) {
            this.form.smtr = years[0].value;
          }
        }

        const storeData = JSON.parse(this.getStore(this.$route.name));
        const patrolId = (this.$route.query && this.$route.query.id) || (storeData && storeData.id);
        if (patrolId) {
          this.loadDetail(patrolId);
        }
      });
    },
    loadDetail(id) {
      const api = "/api/DormitoryPatrol/detail/" + id;
      this.$axios.get(api).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "查無宿舍巡查資料", () => {
            this.$router.replace({ name: "stay.patrol" });
          });
          return;
        }

        const detail = resp.data.data || {};
        const patrolTime = parsePatrolTime(detail.PatrolTime || detail.patrolTime);
        this.form = Object.assign(createDefaultForm(), {
          id: detail.Id || detail.id || null,
          smtr: detail.Smtr || detail.smtr || "",
          patrolDate: this.toDate(detail.PatrolDate || detail.patrolDate),
          patrolHour: patrolTime.hour,
          patrolMinute: patrolTime.minute,
          regularPatrolStatus: detail.RegularPatrolStatus || detail.regularPatrolStatus || "",
          hasFacilityIssue: detail.HasFacilityIssue || detail.hasFacilityIssue || "N",
          hasIncident: detail.HasIncident || detail.hasIncident || "N",
          incidentHandleRemark: detail.IncidentHandleRemark || detail.incidentHandleRemark || "",
          studentFeedback: detail.StudentFeedback || detail.studentFeedback || "",
          violationItem: detail.ViolationItem || detail.violationItem || NO_VIOLATION_ITEM,
          crDate: detail.CrDate || detail.crDate || null,
          facilities: (detail.Facilities || detail.facilities || []).map((item) => ({
            dormitoryName: item.DormitoryName || item.dormitoryName || "",
            floorName: item.FloorName || item.floorName || "",
            issueRemark: item.IssueRemark || item.issueRemark || "",
          })),
          incidentStudents: (detail.IncidentStudents || detail.incidentStudents || []).map((item) => this.normalizeStudent(item)),
          violationStudents: (detail.ViolationStudents || detail.violationStudents || []).map((item) => this.normalizeStudent(item)),
        });
      });
    },
    normalizeStudent(item) {
      return {
        applyId: item.applyId || item.ApplyId || null,
        account: item.account || item.Account || "",
        name: item.name || item.Name || "",
        sex: item.sex || item.Sex || "",
        dormitoryName: item.dormitoryName || item.DormitoryName || "",
        bedRoom: item.bedRoom || item.BedRoom || "",
        bed: item.bed || item.Bed || "",
      };
    },
    toDate(value) {
      return value ? new Date(value) : null;
    },
    floorOptions(dormitoryName) {
      return DORMITORY_FLOOR_MAP[dormitoryName] || [];
    },
    onFacilityDormitoryChange(item) {
      if (this.floorOptions(item.dormitoryName).indexOf(item.floorName) === -1) {
        item.floorName = "";
      }
    },
    onFacilityIssueChange() {
      if (this.form.hasFacilityIssue === "Y") {
        if (!this.form.facilities.length) {
          this.addFacility();
        }
        return;
      }
      this.form.facilities = [];
    },
    onIncidentChange() {
      if (this.form.hasIncident === "Y") {
        if (!this.form.incidentStudents.length) {
          this.addIncidentStudent();
        }
        return;
      }
      this.form.incidentHandleRemark = "";
      this.form.incidentStudents = [];
    },
    onViolationChange() {
      if (this.form.violationItem && this.form.violationItem !== NO_VIOLATION_ITEM) {
        if (!this.form.violationStudents.length) {
          this.addViolationStudent();
        }
        return;
      }
      this.form.violationStudents = [];
    },
    addFacility() {
      this.form.facilities.push(createFacility());
    },
    removeFacility(index) {
      this.form.facilities.splice(index, 1);
    },
    addIncidentStudent() {
      this.form.incidentStudents.push(createStudent());
    },
    removeIncidentStudent(index) {
      this.form.incidentStudents.splice(index, 1);
    },
    addViolationStudent() {
      this.form.violationStudents.push(createStudent());
    },
    removeViolationStudent(index) {
      this.form.violationStudents.splice(index, 1);
    },
    getExistingStudentByAccount(account, targetStudent) {
      const normalized = normalizeAccount(account);
      if (!normalized) {
        return null;
      }

      const allStudents = [].concat(this.form.incidentStudents || [], this.form.violationStudents || []);
      return allStudents.find((student) => {
        if (student === targetStudent) {
          return false;
        }
        if (normalizeAccount(student.account) !== normalized) {
          return false;
        }
        return !!(student.name || student.sex || student.dormitoryName || student.bedRoom || student.bed || student.applyId);
      }) || null;
    },
    syncDuplicateStudentRows(account, sourceStudent) {
      const normalized = normalizeAccount(account);
      if (!normalized) {
        return;
      }

      const allStudents = [].concat(this.form.incidentStudents || [], this.form.violationStudents || []);
      allStudents.forEach((student) => {
        if (student === sourceStudent) {
          return;
        }
        if (normalizeAccount(student.account) !== normalized) {
          return;
        }
        Object.assign(student, this.normalizeStudent(sourceStudent));
      });
    },
    lookupStudent(targetStudent) {
      const account = (targetStudent.account || "").trim();
      targetStudent.account = account;
      if (!account) {
        bootbox.alert("請輸入學生學號");
        return;
      }

      const existingStudent = this.getExistingStudentByAccount(account, targetStudent);
      if (existingStudent) {
        Object.assign(targetStudent, this.normalizeStudent(existingStudent));
        return;
      }

      const api = "/api/DormitoryPatrol/student-info";
      this.$axios.post(api, JSON.stringify({ account })).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "查無有效住宿資料");
          return;
        }
        Object.assign(targetStudent, this.normalizeStudent(resp.data.data || {}));
        this.syncDuplicateStudentRows(account, targetStudent);
      });
    },
    validateForm() {
      if (!this.form.smtr) {
        return "請選擇學期";
      }
      if (!this.form.patrolDate) {
        return "請選擇巡查日期";
      }
      if (!toPatrolTimeText(this.form.patrolHour, this.form.patrolMinute)) {
        return "請選擇巡查時間";
      }
      if (!this.form.regularPatrolStatus) {
        return "請輸入巡查紀錄";
      }
      if (!this.form.hasIncident) {
        return "請選擇偶(突)發事件處理";
      }
      if (!this.form.violationItem) {
        return "請選擇學生違規事項";
      }
      if (this.form.hasFacilityIssue === "Y") {
        if (!this.form.facilities.length) {
          return "請至少新增一筆設施異常資料";
        }
        const invalidFacility = this.form.facilities.find((item) => !item.dormitoryName || !item.floorName || !item.issueRemark);
        if (invalidFacility) {
          return "請完整填寫設施異常資料";
        }
      }
      return "";
    },
    buildSavePayload() {
      return {
        Id: this.form.id,
        Smtr: this.form.smtr,
        PatrolDate: this.form.patrolDate ? this.customFormatter(this.form.patrolDate, "YYYY-MM-DD") + "T00:00:00" : null,
        PatrolTime: toPatrolTimeText(this.form.patrolHour, this.form.patrolMinute),
        RegularPatrolStatus: this.form.regularPatrolStatus,
        HasFacilityIssue: this.form.hasFacilityIssue,
        HasIncident: this.form.hasIncident,
        IncidentHandleRemark: this.form.incidentHandleRemark,
        StudentFeedback: this.form.studentFeedback,
        ViolationItem: this.form.violationItem,
        Facilities: this.form.facilities.map((item) => ({
          DormitoryName: item.dormitoryName,
          FloorName: item.floorName,
          IssueRemark: item.issueRemark,
        })),
        IncidentStudents: this.form.incidentStudents.filter((item) => item.account).map((item) => ({
          Account: item.account,
        })),
        ViolationStudents: this.form.violationStudents.filter((item) => item.account).map((item) => ({
          Account: item.account,
        })),
      };
    },
    savePatrol() {
      const validationMessage = this.validateForm();
      if (validationMessage) {
        bootbox.alert(validationMessage);
        return;
      }

      const api = "/api/DormitoryPatrol/save";
      this.$axios.post(api, JSON.stringify(this.buildSavePayload())).then((resp) => {
        bootbox.alert(resp.data.msg || (resp.data.status === "success" ? "儲存成功" : "儲存失敗"), () => {
          if (resp.data.status === "success") {
            this.removeStore(this.$route.name);
            this.$router.push({ name: "stay.patrol" });
          }
        });
      });
    },
    clickPrevious() {
      this.$router.push({ name: "stay.patrol" });
    },
  },
  mounted() {
    if (!this.guardAccess()) {
      return;
    }
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.removeStore(this.$route.name);
    next();
  },
};
</script>

<style scoped>
.patrol-student-lookup {
  display: flex;
  align-items: center;
  gap: 8px;
}

.patrol-student-lookup .form-control {
  min-width: 0;
}

.patrol-student-lookup-btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

.patrol-time-select-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.patrol-time-select {
  width: 82px;
}

.patrol-time-separator {
  font-weight: 600;
}

@media (max-width: 767px) {
  .patrol-student-lookup {
    flex-direction: column;
    align-items: stretch;
  }

  .patrol-time-select-group {
    justify-content: flex-start;
  }
}
</style>